// src/components/admin/AdminFeedback.js
import React, { useState, useEffect } from 'react';
import { listarFeedback, actualizarFeedback, eliminarFeedback } from '../../services/api';

  const AdminFeedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState({ estado: '', tipo: '' });
  const [estadisticas, setEstadisticas] = useState(null);
  const [feedbackSeleccionado, setFeedbackSeleccionado] = useState(null);
  const [respuesta, setRespuesta] = useState('');
  const [mensaje, setMensaje] = useState({ type: '', text: '' });
  const [estadoRespuesta, setEstadoRespuesta] = useState('resuelto');

  useEffect(() => {
    cargarFeedback();
    cargarEstadisticas();
  }, []);

  const cargarFeedback = async () => {
    setLoading(true);
    try {
      const response = await listarFeedback(filtro);
      setFeedbacks(response.data.feedbacks);
    } catch (error) {
      console.error('Error cargando feedback:', error);
    } finally {
      setLoading(false);
    }
  };

  const cargarEstadisticas = async () => {
    try {
      const response = await listarFeedback('estadisticas');
      setEstadisticas(response.data.estadisticas);
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
    }
  };

  const handleFiltroChange = (e) => {
    setFiltro({
      ...filtro,
      [e.target.name]: e.target.value
    });
  };

  const aplicarFiltros = () => {
    cargarFeedback();
  };

  const handleActualizarEstado = async (id, nuevoEstado) => {
    try {
      await actualizarFeedback(id, { estado: nuevoEstado });
      setMensaje({ type: 'success', text: 'Estado actualizado' });
      cargarFeedback();
      cargarEstadisticas();
      setTimeout(() => setMensaje({ type: '', text: '' }), 3000);
    } catch (error) {
      setMensaje({ type: 'error', text: 'Error al actualizar' });
    }
  };

  const handleGuardarRespuesta = async (id) => {
    if (!respuesta.trim()) return;
    
    try {
      await actualizarFeedback(id, { 
        respuesta_admin: respuesta,
        estado: estadoRespuesta  // ← Usa el estado seleccionado
      });
      setMensaje({ type: 'success', text: 'Respuesta guardada' });
      setFeedbackSeleccionado(null);
      setRespuesta('');
	  setEstadoRespuesta('resuelto');
      cargarFeedback();
      cargarEstadisticas();
      setTimeout(() => setMensaje({ type: '', text: '' }), 3000);
    } catch (error) {
      setMensaje({ type: 'error', text: 'Error al guardar' });
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Eliminar este feedback permanentemente?')) return;
    
    try {
      await eliminarFeedback(id);
      setMensaje({ type: 'success', text: 'Feedback eliminado' });
      cargarFeedback();
      cargarEstadisticas();
      setTimeout(() => setMensaje({ type: '', text: '' }), 3000);
    } catch (error) {
      setMensaje({ type: 'error', text: 'Error al eliminar' });
    }
  };

  const getTipoIcono = (tipo) => {
    const iconos = {
      'bug': '🐛',
      'sugerencia': '💡',
      'mejora': '✨',
      'general': '💬'
    };
    return iconos[tipo] || '📌';
  };

  const getEstadoClass = (estado) => {
    const clases = {
      'pendiente': 'estado-pendiente',
      'en_proceso': 'estado-proceso',
      'resuelto': 'estado-resuelto',
      'rechazado': 'estado-rechazado'
    };
    return clases[estado] || '';
  };

  return (
    <div className="admin-feedback">
      <h2>📢 Feedback de Beta Testers</h2>

      {/* Estadísticas rápidas */}
      {estadisticas && (
        <div className="feedback-stats">
          <div className="stat-card">
            <span className="stat-value">{estadisticas.total}</span>
            <span className="stat-label">Total</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">{estadisticas.pendientes}</span>
            <span className="stat-label">Pendientes</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">{estadisticas.en_proceso}</span>
            <span className="stat-label">En proceso</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">{estadisticas.resueltos}</span>
            <span className="stat-label">Resueltos</span>
          </div>
        </div>
      )}

      {/* Filtros */}
      <div className="feedback-filtros">
        <select name="estado" value={filtro.estado} onChange={handleFiltroChange}>
          <option value="">Todos los estados</option>
          <option value="pendiente">Pendiente</option>
          <option value="en_proceso">En proceso</option>
          <option value="resuelto">Resuelto</option>
          <option value="rechazado">Rechazado</option>
        </select>

        <select name="tipo" value={filtro.tipo} onChange={handleFiltroChange}>
          <option value="">Todos los tipos</option>
          <option value="bug">🐛 Bug</option>
          <option value="sugerencia">💡 Sugerencia</option>
          <option value="mejora">✨ Mejora</option>
          <option value="general">💬 General</option>
        </select>

        <button onClick={aplicarFiltros} className="btn-filtrar">
          Filtrar
        </button>
      </div>

      {mensaje.text && (
        <div className={`mensaje ${mensaje.type}`}>{mensaje.text}</div>
      )}

      {loading ? (
        <div className="loading">Cargando feedback...</div>
      ) : (
        <div className="feedback-list">
          {feedbacks.length === 0 ? (
            <div className="empty-state">
              No hay feedback para mostrar
            </div>
          ) : (
            feedbacks.map(f => (
              <div key={f.id} className="feedback-card">
                <div className="feedback-header">
                  <div className="feedback-titulo">
                    <span className="feedback-icon">{getTipoIcono(f.tipo)}</span>
                    <h3>{f.titulo}</h3>
                  </div>
                  <span className={`feedback-estado ${getEstadoClass(f.estado)}`}>
                    {f.estado}
                  </span>
                </div>

                <div className="feedback-meta">
                  <span>👤 {f.username}</span>
                  <span>📅 {new Date(f.created_at).toLocaleString()}</span>
                  {f.prioridad && (
                    <span className={`prioridad-${f.prioridad}`}>
                      🚩 {f.prioridad}
                    </span>
                  )}
                </div>

                <div className="feedback-descripcion">
                  {f.descripcion}
                </div>

                {f.url && (
                  <div className="feedback-url">
                    <small>📍 URL: {f.url}</small>
                  </div>
                )}

                {f.respuesta_admin && (
                  <div className="feedback-respuesta">
                    <strong>Respuesta del admin:</strong>
                    <p>{f.respuesta_admin}</p>
                  </div>
                )}

                <div className="feedback-acciones">
                  <select 
                    value={f.estado}
                    onChange={(e) => handleActualizarEstado(f.id, e.target.value)}
                    className="estado-select"
                  >
                    <option value="pendiente">⏳ Pendiente</option>
                    <option value="en_proceso">🔄 En proceso</option>
                    <option value="resuelto">✅ Resuelto</option>
                    <option value="rechazado">❌ Rechazado</option>
                  </select>

                  <button 
                    onClick={() => {
                      setFeedbackSeleccionado(f.id);
                      setRespuesta(f.respuesta_admin || '');
                    }}
                    className="btn-responder"
                  >
                    💬 Responder
                  </button>

                  <button 
                    onClick={() => handleEliminar(f.id)}
                    className="btn-eliminar"
                  >
                    🗑️
                  </button>
                </div>

                {feedbackSeleccionado === f.id && (
                  <div className="feedback-respuesta-form">
                    <textarea
                      value={respuesta}
                      onChange={(e) => setRespuesta(e.target.value)}
                      placeholder="Escribe tu respuesta al usuario..."
                      rows="3"
                    />
                   <div className="respuesta-buttons">
					  <select 
						className="estado-respuesta-select"
						value={estadoRespuesta}
						onChange={(e) => setEstadoRespuesta(e.target.value)}
					  >
						<option value="resuelto">✅ Marcar como resuelto</option>
						<option value="en_proceso">🔄 Dejar en proceso</option>
						<option value="pendiente">⏳ Mantener pendiente</option>
					  </select>

					  <button 
						onClick={() => handleGuardarRespuesta(f.id)}
						className="btn-guardar"
					  >
						💾 Guardar respuesta
					  </button>
					  <button 
						onClick={() => setFeedbackSeleccionado(null)}
						className="btn-cancelar"
					  >
						❌ Cancelar
					  </button>
					</div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default AdminFeedback;